var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._b({attrs:{"dense":"","border":"left","type":"info","text":"","color":"accent"}},'v-alert',_vm.alertProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }